import { useQuery, useQueryClient } from "@tanstack/react-query";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import fetch from "logic/rest/FetchProvider";
const CONFIG_URL = "/plugins/org.graylog.plugins.securityapp/tour/config";
export const VERASCEND_TOUR_CONFIG_QUERY_KEY = ["verascend-tour", "config"];
const fetchVerascendTourConfig = () => fetch("GET", qualifyUrl(CONFIG_URL)).catch((error) => {
  UserNotification.error(
    `Fetching Verascend tour configuration failed with status: ${error}`,
    "Could not load Verascend tour configuration"
  );
  return { enabled: true };
});
export const updateVerascendTourConfig = (config) => fetch("PUT", qualifyUrl(CONFIG_URL), config).catch((error) => {
  UserNotification.error(
    `Saving Verascend tour configuration failed with status: ${error}`,
    "Could not save Verascend tour configuration"
  );
  throw error;
});
const useVerascendTourConfig = () => {
  var _a;
  const queryClient = useQueryClient();
  const { data, isLoading } = useQuery({
    queryKey: VERASCEND_TOUR_CONFIG_QUERY_KEY,
    queryFn: fetchVerascendTourConfig,
    retry: false
  });
  const invalidate = () => queryClient.invalidateQueries({ queryKey: VERASCEND_TOUR_CONFIG_QUERY_KEY });
  return {
    enabled: (_a = data == null ? void 0 : data.enabled) != null ? _a : true,
    isLoading,
    invalidateVerascendTourConfig: invalidate
  };
};
export default useVerascendTourConfig;
